/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { GpsOrigin } from "../body/gps_origin";
import { GpsWaypoint } from "../skills/gps_waypoint";

export const protobufPackage = "surface_scan";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface GpsHelperState {
  gpsPolygon: GpsWaypoint[];
  gpsWaypoint: GpsWaypoint | undefined;
  globalMapGpsOrigin: GpsOrigin | undefined;
  overwriteGlobalMapGpsOriginZFromWorldTNavZ: boolean;
}

function createBaseGpsHelperState(): GpsHelperState {
  return {
    gpsPolygon: [],
    gpsWaypoint: undefined,
    globalMapGpsOrigin: undefined,
    overwriteGlobalMapGpsOriginZFromWorldTNavZ: false,
  };
}

export const GpsHelperState = {
  encode(message: GpsHelperState, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.gpsPolygon) {
      GpsWaypoint.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.gpsWaypoint !== undefined) {
      GpsWaypoint.encode(message.gpsWaypoint, writer.uint32(26).fork()).ldelim();
    }
    if (message.globalMapGpsOrigin !== undefined) {
      GpsOrigin.encode(message.globalMapGpsOrigin, writer.uint32(18).fork()).ldelim();
    }
    if (message.overwriteGlobalMapGpsOriginZFromWorldTNavZ === true) {
      writer.uint32(32).bool(message.overwriteGlobalMapGpsOriginZFromWorldTNavZ);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GpsHelperState {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGpsHelperState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.gpsPolygon.push(GpsWaypoint.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.gpsWaypoint = GpsWaypoint.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.globalMapGpsOrigin = GpsOrigin.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.overwriteGlobalMapGpsOriginZFromWorldTNavZ = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GpsHelperState {
    return {
      gpsPolygon: globalThis.Array.isArray(object?.gpsPolygon)
        ? object.gpsPolygon.map((e: any) => GpsWaypoint.fromJSON(e))
        : [],
      gpsWaypoint: isSet(object.gpsWaypoint) ? GpsWaypoint.fromJSON(object.gpsWaypoint) : undefined,
      globalMapGpsOrigin: isSet(object.globalMapGpsOrigin) ? GpsOrigin.fromJSON(object.globalMapGpsOrigin) : undefined,
      overwriteGlobalMapGpsOriginZFromWorldTNavZ: isSet(object.overwriteGlobalMapGpsOriginZFromWorldTNavZ)
        ? globalThis.Boolean(object.overwriteGlobalMapGpsOriginZFromWorldTNavZ)
        : false,
    };
  },

  toJSON(message: GpsHelperState): unknown {
    const obj: any = {};
    if (message.gpsPolygon?.length) {
      obj.gpsPolygon = message.gpsPolygon.map((e) => GpsWaypoint.toJSON(e));
    }
    if (message.gpsWaypoint !== undefined) {
      obj.gpsWaypoint = GpsWaypoint.toJSON(message.gpsWaypoint);
    }
    if (message.globalMapGpsOrigin !== undefined) {
      obj.globalMapGpsOrigin = GpsOrigin.toJSON(message.globalMapGpsOrigin);
    }
    if (message.overwriteGlobalMapGpsOriginZFromWorldTNavZ === true) {
      obj.overwriteGlobalMapGpsOriginZFromWorldTNavZ = message.overwriteGlobalMapGpsOriginZFromWorldTNavZ;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GpsHelperState>, I>>(base?: I): GpsHelperState {
    return GpsHelperState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GpsHelperState>, I>>(object: I): GpsHelperState {
    const message = createBaseGpsHelperState();
    message.gpsPolygon = object.gpsPolygon?.map((e) => GpsWaypoint.fromPartial(e)) || [];
    message.gpsWaypoint = (object.gpsWaypoint !== undefined && object.gpsWaypoint !== null)
      ? GpsWaypoint.fromPartial(object.gpsWaypoint)
      : undefined;
    message.globalMapGpsOrigin = (object.globalMapGpsOrigin !== undefined && object.globalMapGpsOrigin !== null)
      ? GpsOrigin.fromPartial(object.globalMapGpsOrigin)
      : undefined;
    message.overwriteGlobalMapGpsOriginZFromWorldTNavZ = object.overwriteGlobalMapGpsOriginZFromWorldTNavZ ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
